import useAlertStore from "@/store/use-alert-store";
import useAppStore from "@/store/use-app-store";
import { CopyAll, Spellcheck, Subtitles } from "@mui/icons-material";
import { InputAdornment, TextField, Typography } from "@mui/material";
import React from "react";

function Signature({ signature, signatureError, signatureStatus }) {
  const { isMobile } = useAppStore();

  const { setAlert } = useAlertStore();
  return (
    <>
      {signatureStatus && (
        <Typography sx={{ margin: "6px 0" }} variant="h6">
          Статус подписи: {signatureStatus}
        </Typography>
      )}
      {signatureError && (
        <Typography sx={{ margin: "6px 0" }} variant="h6">
          Ошибка подписи: {signatureError}
        </Typography>
      )}
      <TextField
        InputProps={{
          endAdornment: (
            <InputAdornment
              onClick={() => {
                navigator.clipboard.writeText(signature);
                setAlert("Скопировано..");
              }}
              position="end"
              sx={{ cursor: "pointer" }}
            >
              <CopyAll />
            </InputAdornment>
          ),
          startAdornment: (
            <InputAdornment position="start">
              <Subtitles />
            </InputAdornment>
          ),
          style: {
            fontSize: isMobile ? "0.875rem" : "1rem",
          },
        }}
        disabled
        error={signatureError ? true : undefined}
        fullWidth
        helperText={signatureError ? signatureError : undefined}
        // label="Подписываемое сообщение"
        // maxRows={dataObj?.deviceWidth?.isMobile ? 4 : undefined}
        mb={2}
        mt={2}
        multiline={false}
        name="signature"
        // onChange={(e) => props.setComment(e.target.value)}
        // rows={dataObj?.deviceWidth?.isMobile ? undefined : 4}
        // sx={{ margin: "0.875rem 0" }}
        type="text"
        value={signature || ""}
        // variant={dataObj?.deviceWidth?.isMobile ? "standard" : "outlined"}
        variant="standard"
      />
    </>
  );
}

export default Signature;
